import { STATUS } from 'literals';

import * as types from 'types';

export const description = 'Ikigaibot';
export const name = 'Ikigaibot';
export const topic: types.Topic = {
  cached: false,
  data: [],
  message: '',
  status: STATUS.IDLE,
  updatedAt: 0,
};

export const coaches = [
  //   {
  //     name: 'MentorMirror',
  //     avatar: 'BigBroGrammer',
  //     office: 'BigBroGrammer_Office',
  //     primary: '#358d92',
  //     default: '#4dadb3',
  //     chatbotId: 'sQDZt05VVkMrhEG9CNMMJ',
  //     voiceId: 'ErXwobaYiN019PkySvjV',
  //     voiceSettings: {
  //       stability: 0.19,
  //       similarity_boost: 0.69,
  //     },
  //     description:
  //       'Explore what you bring to a mentoring relationship, plan for trust-building through dialogue.',
  //     prompt: `
  // My name is {{name}}. MentorMirror Mission:
  // Step 1: Welcome the mentor and explore the mentor's {{My Interests}} (e.g., "I'm going to help you build trust by modeling vulnerability in your mentoring relationship, {{name}}. What activities do you do for fun? What subjects did you enjoy most in high school?").
  // Step 2: Elicit and validate the mentor's {{My Skills}} (e.g., "What talents or strengths do you want to share as a mentor?").
  // Step 3: Inquire about and affirm the mentor's {{My Values}} (e.g., "What values or principles do you want to share?").
  // Step 4: Investigate and validate the mentor's {{My Worth}} (e.g., "How can you describe the core skills of your profession? What do you do for others?").
  // Step 5: Summarize and affirm what the mentor wants to share, affirming their disclosures and openness.
  // Step 6: Suggest opportunities to invite a high school-aged mentee into the mentor's interests, skills, values, and worth, if their mentee is interested.
  // Step 7: Recap the conversation with all the necessary variables for the output template.
  // Now, begin with Step 1 and pause for the mentor's response before proceeding to the next step.`,
  //   },
  {
    name: 'LearnerLens',
    avatar: 'AuntiePrenneur',
    office: 'AuntiePrenneur_Office',
    primary: '#eb6550',
    default: '#f5806d',
    chatbotId: '2AXCHR4lpS5sdmI_-JZPK',
    voiceId: 'rla6jciKrNUTaXX8UA5W',
    voiceSettings: {
      stability: 0.42,
      similarity_boost: 0.59,
    },
    description:
      'Share your story to help a mentor know you better, build trust, and understand yourself more clearly.',
    prompt: `
You are LearnerLens. My name is {{name}}. Here's your mission:
Step 1: Welcome the user and identify user's {{My Interests}} (e.g., "I'm excited to guide you on this journey, {{name}}. What activities do you enjoy most?").
Step 2: Probe and affirm user's {{My Skills}} (e.g., "What are you really good at?").
Step 3: Inquire and affirm user's {{My Values}} (e.g., "What's important to you in life?").
Step 4: Explore and affirm user's {{My Worth}} (e.g., "What valuable skills can you get paid for?").
Step 5: Summarize and affirm the user's answers, giving them a clear picture of their current identity and potential paths.
Step 6: Suggest aligned {{career interest 01}} and {{career interest 02}} based on user's answers, ask if they would like different suggestions and why?
Step 7: Summarize chat with all variables required by IkigaiOutputTemplate.pdf
Step 8: Remind user to save to their template.
Now start with Step 1 and stop for User response.`,
  },
];

export const initialMessages = new Array(coaches.length);

// eslint-disable-next-line unicorn/prevent-abbreviations
for (let i = 0; i < coaches.length; i++) {
  initialMessages[i] = new Array<types.MessageData>();
}

export const initialQuestions = new Array(coaches.length);

export const functionDefinitions = [
  {
    name: 'get_interests',
    description: "Get summary of user's interests",
    parameters: {
      type: 'object',
      properties: {
        interests: {
          type: 'array',
          items: {
            type: 'string',
            description: 'An interest of the user',
          },
          description: "List of user's interests",
        },
      },
      required: ['interests'],
    },
  },
  {
    name: 'get_values',
    description: "Get summary of user's values",
    parameters: {
      type: 'object',
      properties: {
        values: {
          type: 'array',
          items: {
            type: 'string',
            description: 'A value of the user',
          },
          description: "List of user's values",
        },
      },
      required: ['values'],
    },
  },
  {
    name: 'get_skills',
    description: "Get summary of user's skills",
    parameters: {
      type: 'object',
      properties: {
        skills: {
          type: 'array',
          items: {
            type: 'string',
            description: 'A skill of the user',
          },
          description: "List of user's skills",
        },
      },
      required: ['skills'],
    },
  },
  {
    name: 'get_worth',
    description: "Get summary of user's perceived worth",
    parameters: {
      type: 'object',
      properties: {
        worth: {
          type: 'array',
          items: {
            type: 'string',
            description: 'A perceived of the user',
          },
          description: "List of user's perceived worth",
        },
      },
      required: ['worth'],
    },
  },
  {
    name: 'generate_ikigai_fit_block_01',
    description: 'Return the generated Ikigai fit block text for the first career interest',
    parameters: {
      type: 'object',
      properties: {
        career_interest_1: {
          type: 'string',
          description: 'The first career interest of the user',
        },
        career_interest_1_desc: {
          type: 'string',
          // description: 'Why is this a good fit for the user as the first one?',
          description: 'Why is this a good fit for the user?',
        },
      },
      required: ['career_interest_1', 'career_interest_1_desc'],
    },
  },
  {
    name: 'generate_ikigai_fit_block_02',
    description: "Get user's the second career interest",
    parameters: {
      type: 'object',
      properties: {
        career_interest_2: {
          type: 'string',
          description: 'The second career interest of the user',
        },
        career_interest_2_desc: {
          type: 'string',
          // description: 'Why is this a good fit for the user as the second one?',
          description: 'Why is this a good fit for the user?',
        },
      },
      required: ['career_interest_2', 'career_interest_2_desc'],
    },
  },
];
